module.exports = __webpack_public_path__ + "static/media/elarning-link-bg.3add9612.jpg";